import React from 'react';
import { Phone } from 'lucide-react';

export default function FloatingCTAs() {
  return (
    <>
      {/* Mobile Sticky Call Button */}
      <a
        href="tel:+14077850642"
        className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-[hsl(var(--accent))] text-white h-16 flex items-center justify-center gap-3 font-bold text-lg shadow-2xl active:bg-[#a01830]"
        data-testid="mobile-call-sticky"
      >
        <Phone className="h-6 w-6" />
        Call Now - (407) 785-0642
      </a>
    </>
  );
}